<template>
  <div class="who-we-are-section">
    <div class="container-fluid px-0">
      <div class="row justify-content-center align-items-center m-0">
        <div class="col-12 col-lg-6 who-we-are-image">
        </div>

        <div class="col-12 col-lg-6 who-we-are-content">
          <h2 class="section-title-who">KAS MES ESAME</h2>
          <div class="section-divider-who"></div>
          <div class="who-we-are-text">
            <h4 class="who-subtitle">Mes esame jau begalę patenkintų klientų aptarnavę rinkos dalyviai. Veiklą Lietuvoje vykdome ilga laikotarpį.</h4>
            <p class="who-text">Turime platų paslaugų pasirinkimą tiek lengviems, tiek sunkiasvoriams automobiliams.</p>
            <p class="who-text">
              Įmonės misija – suteikti profesionalias paslaugas kiekvienam klientui. Jūsų pasitikėjimas mumis yra mūsų sėkmės garantas.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhoWeAre"
}
</script>

<style scoped>
.who-we-are-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 80px 20px;
}

.who-we-are-image {
  background-image: url('../../assets/whoarewe.jpeg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 500px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  margin-bottom: 40px;
  transition: transform 0.3s ease;
}

.who-we-are-image:hover {
  transform: scale(1.02);
}

.who-we-are-content {
  padding: 40px;
}

.section-title-who {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  text-align: center;
}

.section-divider-who {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto 30px;
}

.who-we-are-text {
  text-align: left;
}

.who-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.2rem, 2.5vw, 1.5rem);
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
  line-height: 1.5;
}

.who-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #6c757d;
  margin-bottom: 20px;
}

.who-text:last-child {
  margin-bottom: 0;
}

@media (max-width: 992px) {
  .who-we-are-section {
    padding: 60px 15px;
  }
  
  .who-we-are-content {
    padding: 20px;
    text-align: center;
  }
  
  .who-we-are-text {
    text-align: center;
  }
  
  .who-we-are-image {
    min-height: 400px;
  }
}
</style>